import React, { useState } from "react";
import "../css/ServicesTabs.css";

const ServicesTabs = () => {
  const [activeTab, setActiveTab] = useState("ship-repairs");

const tabs = [
  {
    id: "ship-repairs",
    label: "Ship Repairs",
    svgIcon: (
      <svg viewBox="0 0 64 64" width="38" height="38" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 40 L12 28 L52 28 L58 40 Q32 52 6 40Z"/>
        <rect x="16" y="18" width="32" height="10"/>
        <rect x="22" y="10" width="20" height="8"/>
        <line x1="32" y1="10" x2="32" y2="4"/>
        <line x1="26" y1="6" x2="38" y2="6"/>
        <circle cx="22" cy="34" r="2" strokeWidth="1.2"/>
        <circle cx="32" cy="34" r="2" strokeWidth="1.2"/>
        <circle cx="42" cy="34" r="2" strokeWidth="1.2"/>
        <path d="M4 46 Q14 50 24 46 Q34 42 44 46 Q54 50 60 46" strokeWidth="1.2"/>
      </svg>
    ),
  },
  {
    id: "ship-building",
    label: "Shipbuilding",
    svgIcon: (
      <svg viewBox="0 0 64 64" width="38" height="38" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 44 L14 26 L50 26 L56 44 Q32 54 8 44Z" strokeDasharray="4 2.5"/>
        <rect x="18" y="16" width="28" height="10" strokeDasharray="4 2.5"/>
        <rect x="24" y="8" width="16" height="8" strokeDasharray="4 2.5"/>
        <line x1="32" y1="8" x2="32" y2="3" strokeDasharray="3 2"/>
        <line x1="32" y1="26" x2="32" y2="44" strokeDasharray="3 2" strokeWidth="1"/>
        <line x1="14" y1="35" x2="50" y2="35" strokeDasharray="3 2" strokeWidth="1"/>
        <path d="M4 48 Q16 52 28 48 Q40 44 52 48 Q58 50 60 48" strokeWidth="1.2"/>
      </svg>
    ),
  },
  {
    id: "offshore-engineering",
    label: "Offshore Engineering And Conversions",
    svgIcon: (
      <svg viewBox="0 0 64 64" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
        <circle cx="32" cy="14" r="5"/>
        <line x1="22" y1="14" x2="42" y2="14"/>
        <line x1="32" y1="19" x2="32" y2="44"/>
        <path d="M20 44 Q24 52 32 48 Q40 52 44 44"/>
        <circle cx="32" cy="10" r="2" fill="currentColor" strokeWidth="0"/>
        <path d="M8 54 Q18 58 28 54 Q38 50 48 54 Q54 56 56 54" strokeWidth="1.2"/>
      </svg>
    ),
  },
  {
    id: "heavy-engineering",
    label: "Heavy Engineering",
    svgIcon: (
      <svg viewBox="0 0 64 64" width="38" height="38" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
        <line x1="22" y1="6" x2="22" y2="54"/>
        <line x1="22" y1="10" x2="56" y2="10"/>
        <line x1="22" y1="6" x2="48" y2="10"/>
        <line x1="50" y1="10" x2="50" y2="32"/>
        <path d="M46 32 Q46 38 50 38 Q54 38 54 34"/>
        <rect x="16" y="54" width="12" height="4"/>
        <line x1="10" y1="58" x2="34" y2="58"/>
        <rect x="22" y="6" width="10" height="6"/>
      </svg>
    ),
  },
  {
    id: "afloat-repairs",
    label: "Afloat Repairs",
    svgIcon: null,
    icon: "/wp-content/uploads/Afloat Tab Blue.png",
  },
];

  const tabContent = {
    "ship-repairs": {
      title: "Ship Repairs",
      description: `Conveniently located within the port of Colombo, Colombo Dockyard has the ability to conduct both dry dock and afloat repairs. We operate four graving dry docks with a maximum capacity of 125,000 DWT and extensive repair berth facilities. Routine dry docking repairs, major layup repairs, collision damages, conversions and retrofits are professionally expedited. We also have extensive experience in machinery, piping, steel, electricals and electronics.`,
      stats: [
        { value: "200", label: "Vessels Repaired Annually", color: "#673ab7" },
        { value: "100", label: "Accommodated in the Dry Docks", color: "#2196f3" },
        { value: "1000M", label: "Repair Berth", color: "#3f51b5" },
      ],
      image: "/wp-content/themes/cdl/images/Ship Repair Summary.JPG",
    },
    "ship-building": {
      title: "Shipbuilding",
      description: `With over 50 years of experience, Colombo Dockyard has evolved into a formidable force in the regional shipbuilding arena. Our ability to carry out construction of varied vessels that exceed the stringent requirements stipulated by international classification societies whilst at the same time customizing the vessel to meet client requirements has helped pave the way to our success.`,
      stats: [],
      image: "/wp-content/themes/cdl/images/Shipbuilding Summary.JPG",
    },
    "offshore-engineering": {
      title: "OFFSHORE ENGINEERING AND CONVERSIONS",
      description: `Colombo Dockyard offers crucial offshore engineering repair services for mobile offshore drill units, well stimulation vessels, diving support vessels and a host of other related vessels. Our experience and professionalism has helped exceed industry requirements and stringent standards. Our regular customers come from India, France, Norway, and the USA.`,
      stats: [],
      image: "/wp-content/themes/cdl/images/OffShore.png",
    },
    "heavy-engineering": {
      title: "Heavy Engineering",
      description: `Colombo Dockyard Heavy Engineering Department, where innovation meets craftsmanship in the realm of heavy engineering solutions. Delivering innovative solutions that drive progress and enable success for our clients and partners across diverse industries locally and overseas.`,
      stats: [],
      image: "/wp-content/themes/cdl/images/Shell_tank.png",
    },
    "afloat-repairs": {
      title: "AFLOAT REPAIRS",
      description: `RAPID RESPONSE AFLOAT REPAIR SERVICES (RRARS) is set up to provide the discerning ship owners/ship managers with fast response and reliable repair services. This service was established to ensure a relaxed and secure sailing in Indian Ocean by handling challenging repair works while strongly adhering to health and safety regulations.`,
      stats: [],
      image: "/wp-content/themes/cdl/images/Afloat Summary.JPG",
    },
  };

  tabContent["ship-repairs"].extraContent = (
    <div style={{ paddingTop: 40, clear: "both" }}>
        <h2 style={{ textAlign: "center", fontSize: "1.5em", color: "#444", marginBottom: 20, textTransform: "uppercase", fontWeight: 700 }}>
            Colombo Dockyard Completes First Special Survey & Major Accommodation Modification of Pacific Jasper from Eastern Pacific Shipping – Singapore
        </h2>
        <div style={{ margin: "25px 0", display: "flex", justifyContent: "center", width: "100%" }}>
            <img src="/wp-content/uploads/2023/08/ship_repairs_news.png" alt="Pacific Jasper" style={{ maxWidth: "100%", height: "auto", borderRadius: 8 }} />
        </div>
        <p style={{ textAlign: "justify", marginBottom: 15, fontSize: "16px", color: "#555" }}>Colombo Dockyard PLC recently completed a major accommodation refurbishment in parallel with the first special survey docking for Pacific Jasper, a chemical product tanker owned by Eastern Pacific Shipping (EPS) – Singapore.</p>
        <p style={{ textAlign: "justify", marginBottom: 15, fontSize: "16px", color: "#555" }}>At present ship owners and managers face a significant challenge with crew changes. To address this, they not only focus on offering competitive pay but also prioritize providing comfortable accommodations for the crew.</p>
        <p style={{ textAlign: "justify", marginBottom: 15, fontSize: "16px", color: "#555" }}>EPS, placing a strong emphasis on the well-being, comfort, and overall experience of its crew, tasked Colombo Dockyard with an extensive overhaul of key areas within the vessel. The refurbishment included significant upgrades to the mess room, lounge area, ship office, galley, and hospital areas.</p>
        <p style={{ textAlign: "justify", marginBottom: 15, fontSize: "16px", color: "#555" }}>With this project, Colombo Dockyard once again proved its standing as a leading player in the global ship repair industry, known for delivering quality and efficiency.</p>
    </div>
  );

  tabContent["ship-building"].extraContent = (
    <div style={{ paddingTop: 40, clear: "both" }}>
        <h2 style={{ textAlign: "center", fontSize: "1.5em", color: "#444", marginBottom: 20, textTransform: "uppercase", fontWeight: 700 }}>
            Colombo Dockyard PLC (CDPLC) Makes History by Achieving Three Significant Milestones on the Same Day
        </h2>
        <div style={{ margin: "25px 0", display: "flex", justifyContent: "center", width: "100%" }}>
            <img src="/wp-content/uploads/2022/05/Misje_Vita_-_Eco_Bulk_Carrier.jpg" alt="Misje Vita" style={{ maxWidth: "100%", height: "auto", borderRadius: 8 }} />
        </div>
        <p style={{ textAlign: "justify", marginBottom: 15, fontSize: "16px", color: "#555" }}>Colombo Dockyard PLC (CDPLC) made history on June 28, 2024, by achieving three important milestones in shipbuilding on the same day, in the construction of 5000DWT Eco Bulk Carriers for Misje Eco Bulk AS Norway.</p>
        <div style={{ textAlign: "right", marginTop: 20 }}>
            <a title="Colombo Dockyard PLC" className="learn-more" target="_blank" rel="noreferrer" href="/milestone-on-the-same-day.html">View more</a>
        </div>
    </div>
  );

  tabContent["heavy-engineering"].extraContent = (
    <div style={{ paddingTop: 40, clear: "both" }}>
        <h2 style={{ textAlign: "center", fontSize: "1.5em", color: "#444", marginBottom: 20, textTransform: "uppercase", fontWeight: 700 }}>
            Colombo Dockyard builds underwater restaurant structure for Aanugandu Falhu Island Resort, Maldives
        </h2>
        <div style={{ margin: "25px 0", display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
            <img src="/wp-content/uploads/2022/08/Picture1.jpg" alt="Underwater restaurant structure" style={{ maxWidth: "100%", height: "auto", borderRadius: 8 }} />
        </div>
        <p style={{ textAlign: "justify", marginBottom: 15, fontSize: "16px", color: "#555" }}>Colombo Dockyard PLC has successfully completed the contract for the design, supply of materials, fabrication, towing and providing installation guidance of an Underwater Restaurant Structure (UWRS) for Aanugandu Falhu Island in the Republic of Maldives.</p>
        <div style={{ textAlign: "right", marginTop: 20 }}>
            <a title="Colombo Dockyard PLC" className="learn-more" target="_blank" rel="noreferrer" href="/island-resort-maldives.html">View more</a>
        </div>
    </div>
  );

  const current = tabContent[activeTab];

  return (
    <section id="wht-we-do">
      <div
        data-aos="fade-up"
        style={{
          width: "100%",
          background: "#173c95",
          padding: "36px 0",
          marginBottom: 0,
          textAlign: "center",
        }}
      >
        <h3 style={{ fontSize: 20, color: "rgba(255,255,255,0.85)", marginBottom: 8, fontWeight: 500, textTransform: "uppercase", letterSpacing: "2px" }}>
          Our Services
        </h3>
        <h2 className="services-section-title">What We Do</h2>
      </div>

      <div className="center-container" style={{ paddingTop: 40, paddingBottom: 50 }}>
        {/* Tabs */}
        <ul className="services-tab-bar" data-aos="fade-up">
          {tabs.map((tab) => (
            <li
              key={tab.id}
              className={`tab-link ${activeTab === tab.id ? "tab-link-active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">
                {tab.svgIcon ? tab.svgIcon : (
                  <img
                    src={tab.icon}
                    alt={tab.label}
                    style={{ width: 38, height: "auto", objectFit: "contain", filter: activeTab === tab.id ? "brightness(10)" : "none" }}
                  />
                )}
              </span>
              <span className="tab-label">{tab.label}</span>
            </li>
          ))}
        </ul>

        {/* Content */}
        <div className="services-content-wrap">
          <div data-aos="fade-right" className="services-content-left">
            <h2 className="services-heading">{current.title}</h2>
            <p className="services-desc">{current.description}</p>

            {current.stats.length > 0 && (
              <div className="services-stats">
                {current.stats.map((stat, idx) => (
                  <div key={idx} className="services-stat-item">
                    <div className="services-stat-circle" style={{ border: `5px solid ${stat.color}`, color: stat.color }}>
                      {stat.value}
                    </div>
                    <p className="services-stat-label">{stat.label}</p>
                  </div>
                ))}
              </div>
            )}

            <a href={`/services/${activeTab === 'ship-repairs' ? 'ship-repairs' : activeTab === 'ship-building' ? 'shipbuilding' : activeTab === 'offshore-engineering' ? 'offshore' : activeTab === 'heavy-engineering' ? 'heavy-engineering' : 'afloat-repairs'}`} className="learn-more">
              Learn more
            </a>
          </div>

          <div data-aos="fade-left" className="services-content-right">
            <img src={current.image} alt={current.title} className="services-content-img" />
          </div>
        </div>

        {current.extraContent && (
          <div className="wow fadeIn" data-wow-duration="0.8s" style={{ width: "100%" }}>
            {current.extraContent}
          </div>
        )}
        <div style={{ clear: "both" }} />
      </div>
    </section>
  );
};

export default ServicesTabs;